<template>
  <v-layout row wrap white>
    <v-flex xs3 ml-4>
      <v-text-field v-model="code" label="Código do grupo de despesa" />
    </v-flex>
    <v-flex xs4 ml-4>
      <v-text-field
        v-model="name"
        label="Grupo de despesa"
        append-icon="search"
        @click:append="search"
        v-on:keydown.enter.prevent="search"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      name: '',
      code: ''
    }
  },
  props: {
    searchExpGroups: Function
  },
  methods: {
    search () {
      this.searchExpGroups({ name: this.name, code: this.code })
    }
  }
}
</script>

<style>
</style>
